<div class="h-screen flex flex-col overflow-hidden bg-main-bg">
    <app-header></app-header>
<!-- <router-outlet></router-outlet> -->
    <main class="flex-1 overflow-y-auto" tabindex="0">
        <h1 class="sr-only">SS Insights Portal</h1>
        <router-outlet></router-outlet>
    </main>

    <app-footer></app-footer>

    @if (isSessionTimedOut()) {
        <app-session-timeout></app-session-timeout>
    }
</div>